import React from 'react';
import { useQuery } from '@tanstack/react-query';
import Layout from '../components/Layout';
import { listNotifications } from '../api/notificationsService';

const NotificationsHub: React.FC = () => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['notifications-list'],
    queryFn: listNotifications,
  });

  const items = data?.data || [];

  return (
    <Layout>
      <div className="px-4 sm:px-0 max-w-3xl">
        <h1 className="text-2xl font-bold text-gray-900">Notifications</h1>
        <p className="mt-1 text-sm text-gray-600">In-app notification history.</p>

        {isLoading && <p className="mt-6 text-sm text-gray-600">Loading…</p>}
        {isError && (
          <div className="mt-6 rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800">
            Failed to load notifications.{' '}
            <button type="button" className="font-medium underline" onClick={() => refetch()}>
              Retry
            </button>
          </div>
        )}
        {!isLoading && !isError && (
          <div className="mt-6 space-y-4">
            {data?.message ? (
              <p className="text-sm text-gray-600 bg-amber-50 border border-amber-100 rounded-lg p-3">{data.message}</p>
            ) : null}
            {items.length === 0 ? (
              <p className="text-sm text-gray-500 rounded-lg border border-gray-200 bg-white p-6 shadow">
                No notification history yet. Push and in-app alerts may still appear on your mobile device.
              </p>
            ) : (
              <ul className="divide-y divide-gray-200 rounded-lg border border-gray-200 bg-white shadow">
                {items.map((n, i) => (
                  <li key={n.id ?? i} className="px-4 py-3 text-sm text-gray-800">
                    {JSON.stringify(n)}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default NotificationsHub;
